/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 18.08.2016.
 */

import { PendingState, SuccessState, ErrorState } from '../../utils';

import {
  FETCH_NOTIFICATIONS
} from '../../actions/notifications/actions-notifications';

import {
  EMIT_COLLECTION_NOTIFICATION_UPDATE
} from '../../actions/emit/actions-emit';

import {
  INIT_LH_SDK
} from '../../actions/common/actions-common';

const INIT_STATE = {
  notifications: {
    inProgress: false,
    collection: []
  }
};

export default function (state = INIT_STATE, action) {

  switch (action.type) {

    case SuccessState(INIT_LH_SDK):

      return {
        ...state,
        notifications: {
          inProgress: false,
          collection: [...lh.common.notifications]
        }
      };

    case EMIT_COLLECTION_NOTIFICATION_UPDATE:

      return {
        ...state,
        notifications: {
          ...state.notifications,
          collection: [...action.payload]
        }
      };

    case FETCH_NOTIFICATIONS:

      return {
        ...state,
        notifications: {
          inProgress: false,
          collection: [...lh.common.notifications]
        }
      };

    default: {

      return state;
    }
  }

};



// WEBPACK FOOTER //
// ./src/reducers/notifications/reducer-notifications.js